export default __webpack_public_path__ + "static/media/s2img2.454da50f.png";